import { T4Summary } from '@app/models/payroll/t4-summary.model';
import { BadgeColumn } from '@app/modules/table/classes/badge-column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';

export class StatusColumn extends BadgeColumn<T4Summary> {
    title = 'table.employerPackage.status';
    property = 'state';
    sortField = 'state';
    sortable = true;
    type: CellDisplay = CellDisplay.badge;

    getBadgeDisplay(t4Summary: T4Summary): BadgeDisplay | undefined {
        return {
            type: t4Summary.isOpen ? 'informative' : 'success',
            label: t4Summary.state === 'open' ? 'table.employerPackage.open' : 'table.employerPackage.finalized',
        };
    }
}
